var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from "classnames";
import { useEffect, useState } from "react";
var appleKeyNameOverrides = {
    CtrlOrCmd: "⌘",
    Shift: "⇧",
    Alt: "⌥",
    Ctrl: "⌃",
    Return: "⏎",
    Esc: "esc",
    Backspace: "⌫",
    Delete: "⌦",
    Right: "→",
    Left: "←",
    Up: "↑",
    Down: "↓",
    Tab: "⇥",
};
var nonAppleKeyNameOverrides = {
    CtrlOrCmd: "Ctrl",
};
export function KeyboardShortcut(_a) {
    var value = _a.value, _b = _a.isApple, isApple = _b === void 0 ? "auto" : _b, className = _a.className;
    var _c = __read(useState(), 2), isAppleDetected = _c[0], setIsAppleDetected = _c[1];
    useEffect(function () {
        setIsAppleDetected(navigator.platform.includes("Mac") ||
            navigator.platform.includes("iPhone") ||
            navigator.platform.includes("iPad"));
    }, []);
    var resolvedIsApple = isApple === "auto" ? isAppleDetected : isApple;
    if (resolvedIsApple === undefined)
        return null;
    return (<kbd className={classNames("font-sans", className)}>
      {value
            .map(function (key) {
            var overrides = resolvedIsApple
                ? appleKeyNameOverrides
                : nonAppleKeyNameOverrides;
            return key in overrides ? overrides[key] : key;
        })
            .join(resolvedIsApple ? "" : "+")}
    </kbd>);
}
